import { lazy } from "react";

export { CREATE_VACANCY_PATH } from "./create-vacancy-path";
export const CreateVacancyPage = lazy(() => import("./create-vacancy"));
